const options = {
  5: "bg-blue-50/5",
  10: "bg-blue-50/10",
  25: "bg-blue-50/25",
  50: "bg-blue-50/50",
  75: "bg-blue-50/75",
  90: "bg-blue-50/90",
  100: "bg-blue-50",
};

const from = {
  5: "from-blue-50/5",
  10: "from-blue-50/10",
  25: "from-blue-50/25",
  50: "from-blue-50/50",
  75: "from-blue-50/75",
  90: "from-blue-50/90",
  100: "from-blue-50",
};

export default function getBackgroundBlue50(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
